__turbopack_context__.v({
  "chevron": "type-aircraft-select-module-scss-module__cIISlq__chevron",
  "chevronOpen": "type-aircraft-select-module-scss-module__cIISlq__chevronOpen",
  "dropdown": "type-aircraft-select-module-scss-module__cIISlq__dropdown",
  "inputIcon": "type-aircraft-select-module-scss-module__cIISlq__inputIcon",
  "label": "type-aircraft-select-module-scss-module__cIISlq__label",
  "option": "type-aircraft-select-module-scss-module__cIISlq__option",
  "placeholder": "type-aircraft-select-module-scss-module__cIISlq__placeholder",
  "root": "type-aircraft-select-module-scss-module__cIISlq__root",
  "selectContainer": "type-aircraft-select-module-scss-module__cIISlq__selectContainer",
  "selectField": "type-aircraft-select-module-scss-module__cIISlq__selectField",
  "selectText": "type-aircraft-select-module-scss-module__cIISlq__selectText",
  "selected": "type-aircraft-select-module-scss-module__cIISlq__selected",
});
